import React from 'react';
import styled from 'styled-components';
import Icon from '@omilia/icon';
import Button from '@omilia/button';
import { colors } from '@omilia/theme';
import { Text } from '@omilia/typography';

const SContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 15px 30px;
  text-align: center;

  & > * {
    margin: 7px 0;
  }
`;

// TODO: Remove this, when we remove FOUNDATION.
// Right now they exist to override the css that
// FOUNDATION adds
const SButton = styled(Button)`
  &&& {
    border-radius: 5px;
  }
`;

type Props = {
  onClick: () => void;
};

const VersionControlActivation = ({ onClick }: Props) => (
  <SContainer data-test="version-control-activation">
    <Icon
      glyph="notification-warning"
      primaryColor={colors.COLOR_ORANGE_500}
      size="24"
    />
    <Text level={4}>
      To synchronize your project with the GitLab, you must first activate
      version control.
    </Text>
    <SButton
      color="primary"
      size="medium"
      variant="contained"
      onClick={onClick}
    >
      Activate Version Control
    </SButton>
  </SContainer>
);

export default VersionControlActivation;
